import urlJoin from "url-join";

const inquiryFormsSection = "/inquiry-forms/";

export const inquiryFormsListUrl = () => inquiryFormsSection;

export const inquiryFormUrl = (id: string) => urlJoin(inquiryFormsSection, id);

export const inquiryFormCreateUrl = () => urlJoin(inquiryFormsSection, "add");

export enum InquiryFormsUrlQueryParams {
  TAB = "tab",
}

export const InquiryFormsUrlFilters = {
  createFilterTabUtils: () => ({}),
};